import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Toast } from 'antd-mobile';
import ChangePayPwd from '../../components/personal/ChangePayPwd';
import { samePassword } from '../../utils/validate';

class SetPayPwd extends Component {
  constructor() {
    super();
    this.state = {
      pwd: ''
    }
  }
  pwdSureBack = (value) => {
    this.setState({
      pwd: value
    })
  }

  nextStep = () => {
    if (samePassword(this.state.pwd)) {
      Toast.info('请不要设置连续相同的密码！', 2);
      return;
    }
    this.props.pwdFirstSuccess(this.state.pwd);
  }

  render () {
    return (
      <div>
        <ChangePayPwd
          title='设置6位数字支付密码'
          subTitle='支付密码不能为重发、连续的数字'
          btnTitle='下一步'
          pwdSureBack={this.pwdSureBack}
          nextStep={this.nextStep}>
        </ChangePayPwd>
      </div>
    )
  }
}

SetPayPwd.propTypes = {
  pwdFirstSuccess: PropTypes.func,
}

export default SetPayPwd;